import styled from 'styled-components';

export default styled.label({
  display: 'block',
  fontSize: '12px',
  fontWeight: 600,
  paddingBottom: 8,
});

export const LabelBig = styled.label`
  display: 'block';
  fontsize: '14px';
  fontweight: 400;
  paddingbottom: 8;
`;
